import React, {Component} from 'react';
import {passiveMemberInform, resetPassword} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import './User.css';
import {notification} from "antd";
import LoadingIndicator from "../../common/LoadingIndicator";

class PasswordResetEmailModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			isLoading:false,

		};
		this.sendPasswordResetMail = this.sendPasswordResetMail.bind(this);
		this.cancelProcess = this.cancelProcess.bind(this);
		this.handleLogout=this.handleLogout.bind(this);

	}


	sendPasswordResetMail() {
		let self = this;
		const passwordResetRequest = {
			email: this.props.selectedUserEmail,
		};
		self.setState({isLoading:true});
		resetPassword(passwordResetRequest)
			.then(() => {
				notification.success({
					message: 'ŞanlıUrfa Eczacı Odası',
					description: "Şifre Sıfırlama E-postası Gönderildi.",
					duration:30,
				});
				self.setState({isLoading:false});
				this.cancelProcess();
			}).catch(function (error) {
			self.setState({isLoading:false});
			showAxiosError(error);
		});
	}


	cancelProcess() {
		this.props.cancelProcess();
	}

	handleLogout() {
		this.props.handleLogout();
	}

	render() {
		return (
			<div className='oda-form-container'>
				{
					(this.state.isLoading)&&
					<div className="loader">
						<LoadingIndicator/>
					</div>
				}
				<div className='card-header'>
					<h4 className="card-title">{(this.props.selectedUserEmail)
						? this.props.selectedUserName + " " + this.props.selectedUserSurname + " adlı kullanıcıya ait " + this.props.selectedUserEmail + " adresine şifre sıfırlama emaili gönderilecektir. Onaylıyor musunuz?"
						: this.props.selectedUserName + " " + this.props.selectedUserSurname + " adlı kullanıcının e-postası girilmemiş. Öncelikle e-posta giriniz!"
					}</h4>

				</div>
				<div className="modal-footer">
					<div className='col-sm-12 row' id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-8"></div>
						<div className='col-sm-2'>
							<button type="button"
									data-toggle="tooltip"
									data-placement="bottom"
									disabled={(this.props.selectedUserEmail===null) || this.state.isLoading }
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"150px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={() => this.sendPasswordResetMail()}>Onayla
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default PasswordResetEmailModal;



// WEBPACK FOOTER //
// ./src/page/user/PasswordResetEmailModal.js